import { render, staticRenderFns } from "./ReincageInventory.vue?vue&type=template&id=037e3986&scoped=true&"
import script from "./ReincageInventory.vue?vue&type=script&lang=js&"
export * from "./ReincageInventory.vue?vue&type=script&lang=js&"
import style0 from "./ReincageInventory.vue?vue&type=style&index=0&id=037e3986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e3986",
  null
  
)

export default component.exports